import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex xl:flex-row flex-col h-screen" }
const _hoisted_2 = { class: "flex flex-col flex-1 relative overflow-hidden" }

import SidebarMenu from "@/components/SidebarMenu.vue";
import AbsolutePageHeader from "@/components/headers/AbsolutePageHeader.vue";
import PageFooter from "@/components/PageFooter.vue";
import CalculatorSidebarItems from "@/components/sidebar/CalculatorSidebarItems.vue";
import pageBg from "@/assets/calculators/calculator_bg.webp";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  props: {
    showBlogBtn: { type: Boolean, default: true },
    showBgImage: { type: Boolean, default: true }
  },
  setup(__props: any) {



const isMenuOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarMenu, {
      "show-blog-btn": __props.showBlogBtn,
      "is-menu-open": isMenuOpen.value,
      onToggleMenu: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
    }, {
      default: _withCtx(() => [
        _createVNode(CalculatorSidebarItems, {
          onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = false))
        })
      ]),
      _: 1
    }, 8, ["show-blog-btn", "is-menu-open"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(AbsolutePageHeader, {
        "show-blog-btn": true,
        class: "hidden xl:flex"
      }),
      _createElementVNode("section", {
        class: "flex-1 overflow-hidden bg-secondary bg-cover bg-center",
        style: _normalizeStyle(__props.showBgImage ? { backgroundImage: `url(${_unref(pageBg)})` } : {})
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4),
      _createVNode(PageFooter)
    ])
  ]))
}
}

})